import icon from "../../assets/microphone.svg";
import type { Property } from "../../types";

export const twoWayIntercom: Property = {
  id: "twoWayIntercom",
  title: "twoWayIntercom.title",
  icon,
};
